import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientApplicationsRoute = createRoute({
	path: '/applications',
	getParentRoute: () => clientRoute,
});
